import React, { useState, useCallback } from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

import VisibilityIcon from '@material-ui/icons/Visibility';

import { useStore } from '~/store';
import {
  getComparator,
  stableSort,
  getColumns,
  getPropostasContent
} from '~/utils/helpers';
import { propostasDataTable } from '~/utils/constants';

import useStyles from './styles';
import { PropostasTableHeader } from './PropostasTableHeader';

import api from '../../../services/api';

export function PropostasTable({ handleOpenModal }) {
  const { propostas, alert } = useStore();

  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up('md'));
  const sm = useMediaQuery(theme.breakpoints.up('sm'));

  const classes = useStyles({ md, sm });

  const propostasContentData = getPropostasContent({ data: propostas.data });

  const columns = getColumns(propostasDataTable, { md, sm, indexes: [0, 2] });

  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('nome');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [ loading, setLoading ] = useState({ load: false, id: 0 });

  const handleRequestSort = useCallback(
    (e, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    },
    [order, orderBy]
  );

  const handleChangePage = useCallback((event, newPage) => {
    setPage(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback(event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }, []);

  async function handleSelectProposta( id ) {
    setLoading({ load: true, id })
    const response = await api.getProposta( id );

    if( response.statusText === 'OK' ) {
      setLoading({ load: false, id: 0 });

      handleOpenModal( response.data );
    } else {
      alert.addToast({ message: 'Falha!' });

      setLoading({ load: false, id: 0 });
    }
  };

  return (
    <>
      <Paper className={classes.root}>
        <TableContainer className={ classes.table }>
          <Table aria-labelledby="propostas" aria-label="propostas">
            <PropostasTableHeader
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <TableBody>
              {stableSort(propostasContentData, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map(row => {
                  return (
                    <TableRow key={row.pkProposta}>
                      {columns.map(column =>
                        column.id === 'acoes'
                          ? <TableCell>
                              <IconButton
                                onClick={() => handleSelectProposta( row.pkProposta )}
                                color="primary"
                              >
                                { loading.load && loading.id === row.pkProposta ? <CircularProgress size={ 20 } /> : <VisibilityIcon /> }
                              </IconButton>
                            </TableCell>
                          : <TableCell key={column.id}>{row[column.id]}</TableCell>
                      )}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
          <TablePagination
            classes={{
              toolbar: classes.toolbar,
              selectRoot: classes.selectRoot,
              actions: classes.actions
            }}
            labelRowsPerPage="Resultados por página"
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={propostasContentData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </TableContainer>
      </Paper>
    </>
  );
}
